import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { websocketActions } from './websocket.actions';
import { websocketGetters } from './websocket.getters';
import { websocketMutations } from './websocket.mutations';
import { websocketState } from './websocket.state';

export default {
  namespaced: true,
  state: websocketState,
  getters: websocketGetters,
  actions: websocketActions,
  mutations: websocketMutations,
} as ModuleTree<RootState>;
